import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/layout/Navbar";
import HomePage from "@/pages/HomePage";
import DonatePage from "@/pages/DonatePage";
import DonateSuccess from "@/pages/DonateSuccess";
import PetPantryPage from "@/pages/PetPantryPage";
import VolunteerPage from "@/pages/VolunteerPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App min-h-screen bg-[#FDFBF7]">
      <BrowserRouter>
        <Routes>
          {/* Admin routes - no public navbar */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          {/* Public routes */}
          <Route path="/*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/donate" element={<DonatePage />} />
                <Route path="/donate/success" element={<DonateSuccess />} />
                <Route path="/pet-pantry" element={<PetPantryPage />} />
                <Route path="/volunteer" element={<VolunteerPage />} />
              </Routes>
            </>
          } />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
